import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import CardMedia from '@mui/material/CardMedia';
import Link from '@mui/material/Link';

import VenueGallery from 'components/Venue/VenueGallery.tsx';
import VenueMap from 'components/Venue/VenueMap.tsx';

import mosSunset from "gallery/mos-sunset.jpg";

export default function Venue() { 
  return (
    <Box sx={{
      py: 3,
      px: {xs: 0, md: 3},
      alignSelf:"center",
      alignContent: "center",
      alignItems: "center",
      justifyContent: "center",
      display: 'flex',
    }}>
      <Card sx={{ 
          maxWidth: 800,
          width: "100%",
          backgroundColor: "#ffeedd",
          display: 'flex', 
          flexDirection: "column",
        }}>
        <CardHeader 
          title="Venue" 
          titleTypographyProps = {{variant: "h3"}}
          subheader="Boston's Museum of Science"

          />
        <CardMedia
          sx={{ 
            width: "100%",
            objectFit: "contain",
          }}
          component="img"
          image={mosSunset}
          title="Washburn Pavilion!"
        />
        <CardContent>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          Our celebration will be held at the beautiful Washburn Pavilion at Boston's <Link href="https://www.mos.org">Museum of Science</Link>
          <p />
          
          </Typography>

          <VenueGallery />

          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            <ul>
              <li>
              Museum of Science, 1 Science Pk, Boston, MA 02114
              </li>
              <li>
                Free Parking 
              </li>
            </ul>
          
          </Typography>

          <VenueMap />

        </CardContent>
      </Card>
    </Box>
  );
}

